import { AxiosPromise } from "axios";
import { anonymousApi, BaseApi } from "ecom-teams-apps-core";
import { ConfigDto } from "./api/ConfigDto";

export interface ConfigService {
    getConfig(): AxiosPromise<ConfigDto>;
}

export class DefaultConfigService implements ConfigService {
    private getConfigUrl: string = "/public/config";

    constructor(private anonymousApi: BaseApi) {}

    getConfig(): AxiosPromise<ConfigDto> {
        return this.anonymousApi.get<ConfigDto>(this.getConfigUrl);
    }
}

export class ConfigServiceWithResponse implements ConfigService {
    _response: any = {
        data: this.response,
    };

    constructor(private response: any) {}

    getConfig(): AxiosPromise<ConfigDto> {
        return Promise.resolve(this._response);
    }
}

export class ConfigServiceWithError implements ConfigService {
    constructor(private error: any) {}

    getConfig(): AxiosPromise<ConfigDto> {
        return Promise.reject(this.error);
    }
}

export default new DefaultConfigService(anonymousApi);
